var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sign_out") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDA5\\uFE0F-Back-Office",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B\\xE9n\\xE9ficaires",
    transform: "translate(-49.000000, -718.000000)",
    stroke: "#E36565",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(49.750000, 717.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sign_out",
    transform: "translate(0.000000, 2.374611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.41666667,2.33333333 L6.41666667,1.16666667 C6.41666667,0.522334459 5.89433221,0 5.25,0 L1.16666667,0 C0.522334459,0 0,0.522334459 0,1.16666667 L0,8.16666667 C0,8.81099887 0.522334459,9.33333333 1.16666667,9.33333333 L5.25,9.33333333 C5.89433221,9.33333333 6.41666667,8.81099887 6.41666667,8.16666667 L6.41666667,7",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.33333333,4.66666667 L10.5,4.66666667 L8.75,2.91666667 M8.75,6.41666667 L10.5,4.66666667",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign_out.7dbf81c27a24595003ebbb9e5c0f5dd0.svg";
export { ForwardRef as ReactComponent };